module.exports = __webpack_public_path__ + "img/4-3.6f6906a2.svg";